import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { getProductTypeById, ProductTypeModel } from "@tCentro/Services/CENAdminProductTypeService";

export interface GetProductTypeParameter extends HasOnSuccess<ProductTypeModel>, HasOnError<string> {
    id: string;
}

type HandlerType = ApiHandler<GetProductTypeParameter, { apiResult: ProductTypeModel }>;

export const GetProductTypeById: HandlerType = async props => {
    console.log('>>>currentId', props);
    try {
        const result = await getProductTypeById(props.parameter.id);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to load product type");
        }
    }
};

export const chain = [GetProductTypeById];
const getProductTypeData = createHandlerChainRunner(chain, "getProductTypeData");
export default getProductTypeData;